//
// sortTasks
//
// Order task rows the way back-town's /tasks/list ORDER BY does, so client-side merges
// keep server order. The route leads every key with `(col IS NULL)`, which puts undated
// tasks last whichever way the column is sorted.
//
const compareValues = (valueA, valueB) => {
  const missingA = ((valueA === null) || (valueA === undefined));
  const missingB = ((valueB === null) || (valueB === undefined));
  if (missingA || missingB) {
    if (missingA && missingB) return 0;
    return (missingA) ? 1 : -1;
  }
  if (valueA === valueB) return 0;
  if ((typeof valueA === 'number') && (typeof valueB === 'number')) return (valueA - valueB);

  return String(valueA).localeCompare(String(valueB));
};

const sortTasks = (tasks, sortBy) => {
  if (!(sortBy?.length)) return tasks;

  const sorted = [...tasks];
  sorted.sort((taskA, taskB) => {
    for (let i = 0; i < sortBy.length; i += 1) {
      const { key, desc } = sortBy[i];
      const missing = ((taskA[key] === null) || (taskA[key] === undefined))
                      !== ((taskB[key] === null) || (taskB[key] === undefined));
      const cmp = compareValues(taskA[key], taskB[key]);
      // The null test is not part of the direction: undated stays last either way
      if (cmp !== 0) return ((desc) && (!missing)) ? (-cmp) : cmp;
    }
    return 0;
  });

  return sorted;
};

export default sortTasks;
